/**
 * admissionFormSettingApi.js
 * --------------------------
 * Production API client for Admission Form Setting submodule.
 * 100% Zero Mock Data - Direct FastAPI Integration matching Payroll Architecture.
 */
import api from '../../../../api/client'

function toQuery(params = {}) {
  const query = {}
  if (params.searchField && params.searchField !== 'Name') query.searchField = params.searchField
  if (params.searchText) query.searchText = params.searchText
  if (params.company && params.company !== 'All') query.company = params.company
  if (params.branch && params.branch !== 'All') query.branch = params.branch
  return query
}

export async function listAdmissionFormSettings(params = {}) {
  const { data } = await api.get('/admission/admission-form-setting', { params: toQuery(params) })
  return data.items || data || []
}

export async function getAdmissionFormSetting(id) {
  const { data } = await api.get(`/admission/admission-form-setting/${id}`)
  return data
}

export async function createAdmissionFormSetting(payload) {
  const { data } = await api.post('/admission/admission-form-setting', payload)
  return data
}

export async function updateAdmissionFormSetting(id, payload) {
  const { data } = await api.put(`/admission/admission-form-setting/${id}`, payload)
  return data
}

export async function deleteAdmissionFormSetting(id) {
  const { data } = await api.delete(`/admission/admission-form-setting/${id}`)
  return data
}

export default {
  listAdmissionFormSettings,
  getAdmissionFormSetting,
  createAdmissionFormSetting,
  updateAdmissionFormSetting,
  deleteAdmissionFormSetting,
}
